import YklService from 'services/YklService';
import {extractApiErrors} from './api_errors';

const {yklAxios} = YklService;

export const getAllUsers = () => {
    return yklAxios.get('/users/all')
    .then(res => res.data)
    .catch(error => Promise.reject(extractApiErrors(error.response || {})));
}